import { GETALLEMPLOYEEDETAILREPORT } from "../../../utils/api";
import axios from "../../../utils/axios";
export const getemployeeDetailsReport = async () => {
  const res = await axios.get(GETALLEMPLOYEEDETAILREPORT, {
    responseType: "blob",
  });
  return res;
};
